export const pdfFutureFourFunction = (userData, futurePlanData) => {
  let extraExpenseLists = [];
  let expensePerPageLists = [];
  const moneyNeed = () => {
    const findData = futurePlanData?.cash_flow_items?.filter((item) => {
      return item?.remain_accumulate < 0 && item?.remain < 0;
    });
    return findData;
  };

  moneyNeed()?.map((item, index) => {
    item.order = index + 1;
    expensePerPageLists.push(item);
    if (
      expensePerPageLists?.length === 20 ||
      moneyNeed()?.length === item.order
    ) {
      extraExpenseLists.push(expensePerPageLists);
      expensePerPageLists = [];
      return;
    }
    return;
  });

  return extraExpenseLists;
};
